const ordenacoes = {
  relevancia: "maisrelevante",
  "mais-recente": "maisrecente",
  "mais-antigo": "maisantigo"
};

export const ordenacaoParaApi = valor => ordenacoes[valor];

export const ordenacaoParaInterface = valor =>
  Object.keys(ordenacoes).find(chave => ordenacoes[chave] === valor) || "relevancia";

// Adapta o contrato do resumo sem inventar conteúdo ou metadados de artigos.
export default function normalizarResumoFaq(resumo) {
  if (!Array.isArray(resumo)) {
    throw new Error("Formato inválido na resposta do FAQ");
  }

  const artigosPorId = new Map();

  return resumo.map(categoria => ({
    ...categoria,
    titulo: categoria.titulo || "",
    descricao: categoria.descricao || "",
    secoes: (categoria.sessoes || []).map(sessao => ({
      ...sessao,
      titulo: sessao.nome || "",
      descricao: sessao.descricao || "",
      ordenacaoArtigos: ordenacaoParaInterface(sessao.ordenacao),
      artigos: (sessao.artigos || []).map(artigo => {
        if (!artigosPorId.has(artigo.id)) {
          artigosPorId.set(artigo.id, {
            ...artigo,
            titulo: artigo.titulo || "",
            descricao: artigo.descricao || "",
            status: artigo.status
          });
        }
        return artigosPorId.get(artigo.id);
      })
    }))
  }));
}
